import React, { useState, useEffect } from 'react';
import {  notification } from 'antd'

function CandlestickChart() {
  const [images, setImages] = useState([]); // Trạng thái lưu danh sách ảnh
  const showNotification = (message, type) => {
    notification[type]({
      description: message,
      placement: 'topRight', // Notification position
    });
  };
  useEffect(() => {
    fetchImages();
    const interval = setInterval(() => {
      fetchImages();
    }, 10000); // Đặt thời gian lặp lại mỗi 60000 ms (1 phút)

    return () => clearInterval(interval); // Dọn dẹp khi component unmount
  }, []);

  const fetchImages = async () => {
    try {
      const response = await fetch('https://giaminh2021.net/mt6/newest');
      const newImages = await response.json(); // Giả sử API trả về một mảng các URL ảnh mới

      showNotification("Có thêm: " + newImages.length, 'success');

      if (newImages.length > 0) {
        setImages(prevImages => [...prevImages, ...newImages]); // Thêm ảnh mới vào cuối danh sách
      }
    } catch (error) {
      console.error('Failed to fetch new images:', error);
    }
  };

  return (
    <div>
      {images.map((image, index) => (
        <img key={index} src={image} alt={`img-${index}`} />
      ))}
    </div>
  );
}

export default CandlestickChart;
